import React, { Component } from "react";

import { Icon } from "antd";
import PropTypes from "prop-types";

import "react-viewer/dist/index.css";

class CheckBox extends Component {
  state = {
    hover: false
  };

  render() {
    const { userRoleId } = this.props;
    let iconStyle = {
      cursor: this.state.hover ? "pointer" : "default",
      fontSize: 20
    };
    let { checked } = this.props;
    return (
      <div
        onMouseEnter={() => {
          if (userRoleId !== 5) {
            this.setState({ hover: true });
          }
        }}
        onMouseLeave={() => {
          if (userRoleId !== 5) {
            this.setState({ hover: false });
          }
        }}
        onClick={() => {
          if (userRoleId !== 5) {
            this.props.onCheck();
          }
        }}
        style={{ ...iconStyle }}
      >
        <div className="p-phototheque-item-photo-check-btn">
          {checked ? (
            <Icon type="check-circle" theme="filled" />
          ) : (
            <div className="p-phototheque-item-photo-check-btn-empty" />
          )}
        </div>
      </div>
    );
  }
}

CheckBox.propTypes = {
  checked: PropTypes.bool
};

export default CheckBox;



// WEBPACK FOOTER //
// src/components/phototheque/Checkbox.js